import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ConfirmationService } from "primeng/api";
import { AccordionModule } from "primeng/accordion";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-termination-conditions-popup",
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, AccordionModule, TranslateModule],
  templateUrl: "./termination-conditions-popup.component.html",
  styleUrls: ["./termination-conditions-popup.component.scss"],
  providers: [ConfirmationService],
})
export class TerminationConditionsPopupComponent {
  @Input() visible = false;
  @Output() dialogEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  closePopup() {
    this.dialogEmitter.emit(true);
  }
}
